function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + (days*24*60*60*1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
}

function shouldShowPopup() {
  if (localStorage.getItem('newsletterSubscribed')) return false;
  return !getCookie('newsletterShown');
}

window.onload = function() {
  if (shouldShowPopup()) {
    setTimeout(function() {
      document.getElementById("newsletter-popup").style.display = "flex";
    }, 3000);
  }
};

document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("newsletter-popup");
  const closeBtn = document.querySelector(".popup-close");
  const form = popup.querySelector("form");
  const input = popup.querySelector('input[type="email"]');

  // 🧩 Prevent Shopify redirect
  form.setAttribute("onsubmit", "return false;");

  // Close popup manually
  closeBtn.onclick = function() {
    popup.style.display = "none";
    setCookie('newsletterShown', 'true', 1);
  };

  // Handle form submit via AJAX
  form.addEventListener("submit", function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const email = input.value.trim();
    if (!email) return alert("Please enter a valid email");

    fetch(window.location.href, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        "form_type": "customer",
        "contact[email]": email,
        "contact[tags]": "newsletter"
      })
    })
    .then(() => {
      form.innerHTML = `
        <h3 class="newsletter-form__message newsletter-form__message--success form__message" id="Newsletter-success--lovekiki" tabindex="-1" autofocus>
          <span class="svg-wrapper">✅</span>
          Thank you for subscribing!
        </h3>
      `;
      setTimeout(() => popup.style.display = "none", 2000);

      localStorage.setItem('newsletterSubscribed', 'true');
      setCookie('newsletterShown', 'true', 7);
    })
    .catch(() => alert("Something went wrong. Please try again."));
  });
});
